import { render, staticRenderFns } from "./collectionDetails.vue?vue&type=template&id=e5ec77e4&scoped=true&"
import script from "./collectionDetails.vue?vue&type=script&lang=js&"
export * from "./collectionDetails.vue?vue&type=script&lang=js&"
import style0 from "./collectionDetails.vue?vue&type=style&index=0&id=e5ec77e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ec77e4",
  null
  
)

export default component.exports